<template>
  <div>
    <div class="page_title">新增产品</div>
    <div class="form_container">
      <form class="form">
        <div class="form_row">
          <div class="label">产品名称</div>
          <input class="input" placeholder="产品名称" v-model="name">
        </div>
        <div class="form_row">
          <div class="label">产品分类</div>
          <select class="formSelect" v-if="zmIdentity == 'true'" v-model="classify">
            <option v-for="item of classifyList" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
          <input v-else class="input" placeholder="产品分类" v-model="classifyDefault" disabled>
        </div>
        <div class="form_row">
          <div class="label">价格</div>
          <input class="input" placeholder="价格" v-model="price">
        </div>
        <div class="form_row">
          <div class="label">单位</div>
          <input class="input" placeholder="单位" v-model="priceUnit" disabled/>
        </div>
        <div class="form_row">
          <div class="label">最小购买数量</div>
          <input class="input" type="number" placeholder="最小购买数量" v-model="minNum"/>
        </div>
        <div class="form_row">
          <div class="label">最大购买数量</div>
          <input class="input" type="number" placeholder="最大购买数量" v-model="maxNum"/>
        </div>
        <div class="button_container">
          <a href="javascript:" role="button" class="weui-btn weui-btn_primary" @click="submitProduct">确认</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {addProduct,modProduct} from '../api';
import  {queryProductByPosId} from '../graphql/api';
export default {
  name: "add_product",
  data() {
    return {
      zmIdentity: sessionStorage.getItem('zmEmployee'),
      name: '',
      partnerId: sessionStorage.getItem('partnerid'),
      posId: '',
      price: '',
      priceUnit: '分',
      minNum: '',
      maxNum: '',
      state: 1,
      stateList: [{
        id: 1,
        name: '在售'
      },{
        id: 0,
        name: '下架'
      }],

      classify: 6,
      classifyDefault: '商家自定义产品',
      classifyList: [
        {
          id: 0,
          name: '其他'
        },{
          id: 1,
          name: '洗车服务类'
        },{
          id: 2,
          name: '洗车券类'
        },{
          id: 3,
          name: '代金券类'
        },{
          id: 4,
          name: '众敏链点类'
        },{
          id: 5,
          name: '有车邦充值类'
        },{
          id: 6,
          name: '商家自定义产品'
        },{
          id: 10,
          name: '余额充值保留类'
        }
      ]
    }
  },
  mounted() {
    if(this.$route.params.posId){
      this.posId = this.$route.params.posId;
      let params = {
        posId: this.posId,
        page: 1
      }
      this.queryNowProduct(params)
    }else{
      alert('缺少posId!');
    }

    if(this.$route.params.product){
      this.product = this.$route.params.product.product;
      console.log(this.$route.params.product);
      console.log('当前产品', this.product);

      this.name = this.product.name;
      this.classify = this.product.classify;
      this.price = this.product.price;
      this.priceUnit = this.product.priceUnit;
      this.minNum = this.product.minNum;
      this.maxNum = this.product.maxNum;
      this.state = this.$route.params.product.p2p.supported;
      console.log(this.name, this.classify, this.posId, this.price, this.priceUnit, this.minNum, this.maxNum, this.state);
    }


  },
  methods: {
    queryNowProduct(params){
      queryProductByPosId(params).then(res =>{
        console.log('查询产品详情信息', res);
      })
    },

    // 获取默认产品类型
    getClassifyDefault(){
      if(this.classify == 0){
        this.classifyDefault = '其他'
      }else if(this.classify == 1){
        this.classifyDefault = '洗车服务类'
      }else if(this.classify == 2){
        this.classifyDefault = '洗车券类'
      }else if(this.classify == 3){
        this.classifyDefault = '代金券类'
      }else if(this.classify == 4){
        this.classifyDefault = '众敏链点类'
      }else if(this.classify == 5){
        this.classifyDefault = '有车邦充值类'
      }else if(this.classify == 6){
        this.classifyDefault = '商家自定义产品'
      }else if(this.classify == 10){
        this.classifyDefault = '余额充值保留类'
      }
    },

    // 确认
    submitProduct(){
      if(!this.product){
        this.newProduct()
      }else{
        this.modifyProduct()
      }
    },

    // 新增产品
    newProduct(){
      let openId = sessionStorage.getItem('openid');
      let params = {
        name: this.name,
        classify: Number(this.classify),
        partnerId: this.partnerId,
        posId: this.posId,
        price: this.price,
        priceUnit: this.priceUnit,
        minNum: Number(this.minNum),
        maxNum: Number(this.maxNum),
        state: 1
      }
      addProduct(openId,params).then(res => {
        if(res.data.retcode == 0){
          alert('新增产品成功');
          this.$router.go(-1)
        }
        console.log('新增产品响应', res);
      }).catch(err => {
        alert(`${err}`)
      })
    },

    modifyProduct() {
      let openId = sessionStorage.getItem('openid');
      let productType = this.product.productType;
      let params = {
        name: this.name,
        classify: Number(this.classify),
        partnerId: this.partnerId,
        posId: this.posId,
        price: this.price,
        priceUnit: this.priceUnit,
        minNum: Number(this.minNum),
        maxNum: Number(this.maxNum),
        state: 1
      }
      modProduct(openId,productType,params).then(res => {
        if(res.data.retcode == 0){
          alert('产品修改成功');
          this.$router.go(-1)
        }
        console.log('修改产品响应', res);
      }).catch(err => {
        alert(`${err}`)
      })
    }
  }
}
</script>

<style src="../css/add_partner.css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/add_product.vue